<template>
  <div class="brand-side">
    <h2
      v-if="!!community || !!card"
      class="title-strat"
    >
      En lien avec cet article
    </h2>
    <div class="cards-container">
      <CommunityItem
        v-if="community"
        :community="community"
        flexible
        class="community card"
      />
      <ActuPlaystationItem
        v-if="card"
        :actu="card"
        flexible
        class="card"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FormattedArticle } from '~/types'
type SideContent = NonNullable<FormattedArticle['sideContent']>

defineProps<{
  community?: SideContent['community']
  card?: SideContent['card']
}>()
</script>

<style lang="scss" scoped>
.brand-side {
  height: 100%;
  padding: 10rem 8rem;
  padding-bottom: 4rem;
  background: $sideGrey;

  .title-strat {
    margin-bottom: 4.9rem;
  }

  .community {
    margin-bottom: 2.8rem;
  }
}

@media screen and (max-width: 1024px) {
  .brand-side {
    .cards-container {
      display: flex;
      justify-content: space-between;
    }
  }
}

@media screen and (max-width: 700px) {
  .brand-side {
    padding: 4rem 2.5rem;

    .cards-container {
      flex-wrap: wrap;
      justify-content: center;

      .card {
        flex-basis: 100%;

        &:first-child {
          margin-bottom: 2rem;
        }
      }
    }
  }
}
</style>
